import React from 'react';

const TermsOfService = () => {
  return (
    <div>
      {/* Hero */}
      <section className="bg-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Terms of Service</h1>
          <p className="text-slate-300">Last updated: May 21, 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          <p className="text-slate-700">
            These Terms of Service ("Terms") govern your access to and use of the website and services provided by Progress Insurance Solutions LLC ("Progress Insurance Solutions," "we," "us," or "our"). By using our Site or services, you agree to these Terms.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">1. Services</h2>
          <p className="text-slate-700">
            Progress Insurance Solutions is an independent insurance agency that helps clients obtain quotes and coverage from multiple insurance carriers. Information on this Site is provided for general informational purposes and does not constitute insurance advice or a binding offer of coverage.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">2. SMS Terms of Service</h2>
          <p className="text-slate-700">
            By opting into SMS messages from a web form or other medium, you are agreeing to receive SMS messages from Progress Insurance Solutions LLC. This includes SMS messages for conversations (external), quote follow-ups, appointment reminders, policy notifications, and account-related updates.
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2">
            <li><strong>Messaging frequency may vary.</strong></li>
            <li><strong>Message and data rates may apply.</strong></li>
            <li><strong>To opt out at any time, text STOP</strong> to any message you receive from us. You will receive a final confirmation that you have unsubscribed.</li>
            <li><strong>For assistance, text HELP</strong> or visit our website at{' '}
              <a href="https://progressinsure.com" className="text-[#C9A361] hover:underline">https://progressinsure.com</a>.
            </li>
            <li>
              Visit{' '}
              <a href="/privacy-policy" className="text-[#C9A361] hover:underline">https://progressinsure.com/privacy-policy</a>
              {' '}for our privacy policy and{' '}
              <a href="/terms-of-service" className="text-[#C9A361] hover:underline">https://progressinsure.com/terms-of-service</a>
              {' '}for our Terms of Service.
            </li>
            <li>Carriers (such as AT&T, Verizon, T-Mobile, and others) are not liable for delayed or undelivered messages.</li>
          </ul>
          <p className="text-slate-700 mt-4 font-semibold bg-[#F5F1E8] border-l-4 border-[#C9A361] p-4">
            SMS consent is not shared with third parties. We do not sell, rent, or share your mobile phone number or SMS opt-in information with third parties or affiliates for their marketing purposes.
          </p>
          <p className="text-slate-700 mt-4 italic">
            Example consent language: "By opting into SMS from a web form or other medium, you are agreeing to receive SMS messages from Progress Insurance Solutions LLC. This includes SMS messages for conversations (external). Message frequency varies. Message and data rates may apply. See privacy policy at{' '}
            <a href="/privacy-policy" className="text-[#C9A361] hover:underline">https://progressinsure.com/privacy-policy</a>. Message HELP for help. Reply STOP to any message to opt out."
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">3. Eligibility</h2>
          <p className="text-slate-700">
            You must be at least 18 years of age and able to enter into a binding contract to use our services or request a quote.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">4. Accuracy of Information</h2>
          <p className="text-slate-700">
            You agree to provide accurate, current, and complete information when requesting a quote or otherwise interacting with us. Misrepresentations may affect your ability to obtain or maintain coverage.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">5. Intellectual Property</h2>
          <p className="text-slate-700">
            All content on this Site, including text, graphics, logos, and images, is the property of Progress Insurance Solutions LLC or its licensors and is protected by intellectual property laws. You may not copy, distribute, or use any content without our prior written permission.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">6. Third-Party Links</h2>
          <p className="text-slate-700">
            Our Site may contain links to third-party websites. We are not responsible for the content, privacy practices, or services of those websites.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">7. Disclaimers</h2>
          <p className="text-slate-700">
            The Site and its content are provided "as is" and "as available," without warranties of any kind, express or implied. We do not guarantee that the Site will be uninterrupted, error-free, or completely secure. Insurance products are subject to the terms, conditions, and exclusions of the policy issued by the relevant carrier.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">8. Limitation of Liability</h2>
          <p className="text-slate-700">
            To the maximum extent permitted by law, Progress Insurance Solutions LLC will not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Site or our services.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">9. Indemnification</h2>
          <p className="text-slate-700">
            You agree to indemnify and hold harmless Progress Insurance Solutions LLC and its officers, employees, and agents from any claims, damages, or expenses arising out of your use of the Site or your violation of these Terms.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">10. Governing Law</h2>
          <p className="text-slate-700">
            These Terms are governed by the laws of the State of Florida, without regard to its conflict of laws principles. Any dispute will be brought in the state or federal courts located in Broward County, Florida.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">11. Changes to These Terms</h2>
          <p className="text-slate-700">
            We may update these Terms from time to time. The "Last updated" date at the top of this page indicates when it was last revised. Continued use of our Site or services after changes are posted constitutes acceptance of the updated Terms.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">12. Contact Us</h2>
          <p className="text-slate-700">
            For questions about these Terms, please contact:
          </p>
          <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mt-4">
            <p className="font-semibold text-slate-900">Progress Insurance Solutions LLC</p>
            <p className="text-slate-700">Coral Springs: 3111 N University Dr Ste 404, Coral Springs, FL 33065</p>
            <p className="text-slate-700">Maitland: 500 N Maitland Ave Ste 304, Maitland, FL 32751</p>
            <p className="text-slate-700">Phone: <a href="tel:954-495-2929" className="text-[#C9A361] hover:underline">954-495-2929</a></p>
            <p className="text-slate-700">Email: <a href="mailto:contact@progressinsure.com" className="text-[#C9A361] hover:underline">contact@progressinsure.com</a></p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
